import { useEffect, useState } from "react";
import "./App.css";
export const MVXStats = () => {
  const [data, setData] = useState([]);
  const [dataloaded, setDataLoaded] = useState(false);

  function formatNumber(num, locale = "en-US") {
    return new Intl.NumberFormat(locale).format(num);
}

  
  const getData = (tgUsers) => {
    try {
      fetch(
        "https://api.multiversx.com/tokens?identifiers=EMR-d10ed9%2CEMRS-6e4067%2CWEMR-3af159"
      )
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          setData(data);
          console.log(data);
          //       setPhotos(data);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    getData();
  }, []);
  return (
    <>
    <div className="section">
      <div
        style={{
          padding: 20,
          width:'100%'
        }}
      >

<div className="glowBox" style={{
    padding:20,
    
}}>

<div
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop:0
              }}
            >
              <img
                src={"https://tools.multiversx.com/assets-cdn/tokens/EMR-d10ed9/icon.svg"}
                style={{
                  height: 60,
                  marginTop:20
                }}
              />
              <div
                style={{
                  paddingLeft: 20,
                  fontSize: 11,
                  fontWeight: "bold",
                  lineHeight:2
                }}
              >
                <strong
                  style={{
                    fontSize: 20,
                  }}
                >
                  Emorya
                </strong>
                <br />
                <span onClick={() => {
                    global.openUrl('https://emorya.com')
                }}>
https://emorya.com

                </span>
                
                <br/>
                <span style={{
                    fontSize:12
                }}>
                    <span onClick={() => {
                    global.openUrl('https://emorya.com')
                }}><i class="fa-regular fa-envelope"></i></span>
                
                &nbsp;
                &nbsp;
                &nbsp;

                <span onClick={() => {
                    global.openUrl('https://twitter.com/EmoryaFinance')
                }}><i class="fa-brands fa-x-twitter"></i></span>
                
                &nbsp;
                &nbsp;
                &nbsp;


                <span onClick={() => {
                    global.openUrl('https://t.me/EmoryaFinanceRO')
                }}><i class="fa-brands fa-telegram"></i></span>
                
                &nbsp;
                &nbsp;
                &nbsp;


                <span onClick={() => {
                    global.openUrl('https://emorya.com/emorya-white-paper')
                }}><i class="fa-regular fa-file-lines"></i></span>
                
                
              
                
                </span>

              </div>
            </div>

</div>

        {data.map((item, index) => {
            return (

 
          <div style={{
            borderBottomWidth:(index != 2) ? 1 :0,
            borderBottomColor:'#999',
            borderBottomStyle:'dashed',
            paddingTop:10,
            paddingBottom:10

          }}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop:10
              }}
            >
              <img
                src={item.assets.pngUrl}
                style={{
                  height: 40,
                }}
              />
              <div
                style={{
                  paddingLeft: 10,
                  fontSize: 11,
                  fontWeight: "bold",
                }}
              >
                <strong
                  style={{
                    fontSize: 13,
                  }}
                >
                  Emorya {item.ticker}
                </strong>
                <br />
                {item.assets.description}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
              }}
            >
              <div className="statsBox">
                <span>Price</span>
                {(item.price) ? parseFloat(item.price).toFixed(5) : '-'}
              </div>
              <div className="statsBox">
                <span>Circulating Supply</span>
                {(item.circulatingSupply) ? formatNumber(parseInt(item.circulatingSupply/1000000000)) : '-'}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <div className="statsBox">
                <span>Market Cap</span>
                 {(item.marketCap) ? "$" + formatNumber(parseInt(item.marketCap)) : '-'}
              </div>
              <div className="statsBox">
                <span>Holders</span>
                {(item.accounts) ? item.accounts : '-'}
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <div className="statsBox">
                <span>Transactions</span>
                {(item.transfers) ? formatNumber(item.transfers) : '-'}
              </div>
            </div>
            </div>
                     )
        })}
      </div>
      <div style={{
        height:200
      }}></div>
      </div>
    </>
  );
};
